import React from 'react'
import { Grid } from '@material-ui/core'
import {
  InputHLPure,
  ArrowBtnHLPure,
  ButtonHLPure,
  SubtitlePageHLPure,
  DialogSystemGLPure,
} from '../../../pures'
import './user-administration-datails.view.css'
import { profileIconDefault } from '../../../../assets/logos/icons'

const UserAdministrationDetailsView = ({
  selectedUser,
  hideShowDetails,
  setNameComponentUser,
  setHeaderTitleinDetail,
  setShowComponentDetail,
  showDetailComponent,
  setShowDetails,
  imgProfileSubtitle,
  showLoadingRequesting,
  showCompletedRequesting,
  showErrorRequesting,
  toggleCompletedRequesting,
  toggleLoadingRequesting,
  toggleErrorRequesting,
  message,
  t,
}) => {
  const redirectToComponets = (e) => {
    setNameComponentUser(e.currentTarget.dataset.id)
    setHeaderTitleinDetail({ clicked: true, name: e.currentTarget.dataset.id })
    setShowComponentDetail(true)
  }

  return (
    <>
      <header className='userAdministrationDetailsView-header'>
        <SubtitlePageHLPure
          subtitle={t('userAdministrationDetailsView.title')}
          imgProfile={profileIconDefault}
          profileImg={imgProfileSubtitle}
          tooltipShow
          informationIcon={false}
          justShowImg
          openTooltipDescription={false}
        />
      </header>

      <section className='userAdministrationDetailsView-body'>
        <div className='userAdministrationDetailsView-form'>
          <div className='userAdministrationDetailsView-inputs'>
            <div className='userAdministrationDetailsView-inputHLPure'>
              <InputHLPure
                labelInput={t('userAdministrationDetailsView.user.name')}
                valueInput={selectedUser.firstName}
                typeInput={'text'}
                inputActive
                tooltipShow={false}
              />
            </div>
            <div className='userAdministrationDetailsView-inputHLPure'>
              <InputHLPure
                labelInput={t('userAdministrationDetailsView.lastname')}
                valueInput={selectedUser.firstLastName}
                inputActive
                tooltipShow={false}
              />
            </div>
            <div className='userAdministrationDetailsView-inputHLPure'>
              <InputHLPure
                labelInput={t('userAdministrationDetailsView.second.lastname')}
                valueInput={selectedUser.secondLastName}
                inputActive
                tooltipShow={false}
              />
            </div>
            <div className='userAdministrationDetailsView-inputHLPure'>
              <InputHLPure
                labelInput={t('userAdministrationDetailsView.cellphone.number')}
                valueInput={selectedUser.cellphoneNumber}
                inputActive
                tooltipShow={false}
              />
            </div>
            <div className='userAdministrationDetailsView-inputHLPure'>
              <InputHLPure
                labelInput={t('userAdministrationDetailsView.curp')}
                valueInput={selectedUser.curp}
                inputActive
                tooltipShow={false}
              />
            </div>
            <div className='userAdministrationDetailsView-inputHLPure'>
              <InputHLPure
                labelInput={t('userAdministrationDetailsView.rfc')}
                valueInput={selectedUser.rfc}
                inputActive
                tooltipShow={false}
              />
            </div>
          </div>
          <div className='userAdministrationDetailsView-btnGroup'>
            <div className='userAdministrationDetailsView-spaceBtns'>
              <ArrowBtnHLPure
                primary={false}
                textArrowBtn={t(
                  'userAdministrationView.grid.actions.assign.roles'
                )}
                onClickArrowBtn={() => {
                  setNameComponentUser(
                    t('userAdministrationView.grid.actions.assign.roles')
                  )
                  setShowDetails(true)
                }}
                dataSetProp={t(
                  'userAdministrationView.grid.actions.assign.roles'
                )}
              />
            </div>
            <div className='userAdministrationDetailsView-spaceBtns'>
              <ArrowBtnHLPure
                primary={false}
                textArrowBtn={t(
                  'userAdministrationView.grid.actions.assign.companies'
                )}
                onClickArrowBtn={() => {
                  setNameComponentUser(
                    t('userAdministrationView.grid.actions.assign.companies')
                  )
                  setShowDetails(true)
                }}
                dataSetProp={t(
                  'userAdministrationView.grid.actions.assign.companies'
                )}
              />
            </div>
            <div className='userAdministrationDetailsView-spaceBtns'>
              <ArrowBtnHLPure
                primary={false}
                textArrowBtn={t('userAdministrationView.grid.actions.disable')}
                onClickArrowBtn={() => {
                  setNameComponentUser(
                    t('userAdministrationView.grid.actions.disable')
                  )
                  setShowDetails(true)
                }}
                dataSetProp={t('userAdministrationView.grid.actions.disable')}
              />
            </div>
            <ButtonHLPure
              primary
              nameBtn={t('button.return')}
              onClickBtn={hideShowDetails}
            />
            <DialogSystemGLPure
              showLoadingRequesting={showLoadingRequesting}
              showCompletedRequesting={showCompletedRequesting}
              showErrorRequesting={showErrorRequesting}
              toggleLoadingRequesting={toggleLoadingRequesting}
              toggleCompletedRequesting={toggleCompletedRequesting}
              toggleErrorRequesting={toggleErrorRequesting}
              message={message}
            />
          </div>
        </div>
      </section>
    </>
  )
}

export default UserAdministrationDetailsView
